import { render } from "./ErrorSave.vue?vue&type=template&id=40c5c3fd&ts=true"
import script from "./ErrorSave.vue?vue&type=script&lang=ts"
export * from "./ErrorSave.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__